/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_UpdatedInputs */

const en_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const de_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const fr_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const es_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const it_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const nl_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const pl_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const fi_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const da_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

const sv_story_bank_toast_updated = /** @type {(inputs: Story_Bank_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story updated`)
};

/**
* | output |
* | --- |
* | "Story updated" |
*
* @param {Story_Bank_Toast_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_updated = /** @type {((inputs?: Story_Bank_Toast_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_updated(inputs)
	if (locale === "fr") return fr_story_bank_toast_updated(inputs)
	if (locale === "es") return es_story_bank_toast_updated(inputs)
	if (locale === "it") return it_story_bank_toast_updated(inputs)
	if (locale === "nl") return nl_story_bank_toast_updated(inputs)
	if (locale === "pl") return pl_story_bank_toast_updated(inputs)
	if (locale === "fi") return fi_story_bank_toast_updated(inputs)
	if (locale === "da") return da_story_bank_toast_updated(inputs)
	if (locale === "sv") return sv_story_bank_toast_updated(inputs)
	return en_story_bank_toast_updated(inputs)
});